import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";

export default function ShopBy() {
  const { axis } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null); setNotFound(false);
    api.get(`/coin-merch/${axis}`)
      .then((r) => {
        setData(r.data);
        document.title = `${r.data.title} — 999 Gold & Silver Coins | Siyaara`;
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
        meta.content = r.data.intro;
      })
      .catch(() => setNotFound(true));
  }, [axis]);

  if (notFound) {
    return (
      <div className="container-x py-20 text-center" data-testid="shopby-not-found">
        <h1 className="font-heading text-2xl font-semibold">This edit isn't available</h1>
        <Link to="/coins" className="text-brand underline mt-4 inline-block">Browse all coins</Link>
      </div>
    );
  }
  if (!data) return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">LOADING…</div>;

  return (
    <div className="container-x py-8" data-testid="shopby-page">
      <p className="eyebrow">999 FINE COINS</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-1" data-testid="shopby-title">{data.title}</h1>
      <p className="text-stone-600 mt-3 max-w-3xl leading-relaxed">{data.intro}</p>
      <div className="mt-4">
        <Link to="/coin-selector" className="text-sm text-brand underline underline-offset-4" data-testid="shopby-selector-link">
          Not sure which one? Try our guided coin selector →
        </Link>
      </div>

      {data.cards.length === 0 ? (
        <p className="text-stone-500 mt-10" data-testid="shopby-empty">These pages go live as designs come into stock. Please check back soon.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {data.cards.map((c, i) => (
            <Link key={c.key} to={`/jewellery/${c.key}`}
              className="group bg-white border border-brand/10 rounded-xl overflow-hidden transition-shadow hover:shadow-[0_8px_30px_rgba(55,34,72,0.10)] animate-fade-up"
              style={{ animationDelay: `${Math.min(i, 8) * 60}ms` }}
              data-testid={`shopby-card-${c.key}`}>
              <div className="aspect-square bg-ivory overflow-hidden">
                {c.image
                  ? <img src={c.image} alt={c.label} loading="lazy" className="h-full w-full object-cover group-hover:scale-[1.04] transition-transform duration-700" />
                  : <div className="h-full w-full grid place-items-center text-stone-300 font-mono text-xs">SIYAARA</div>}
              </div>
              <div className="p-3.5">
                <p className="font-heading font-semibold text-[15px] group-hover:text-brand transition-colors line-clamp-1">{c.label}</p>
                <p className="text-[11px] font-mono text-stone-500 mt-0.5">{c.count} DESIGN{c.count > 1 ? "S" : ""} · PRICED LIVE</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
